<h1 mat-dialog-title>Choose dosage type and package types</h1>
<div mat-dialog-content>
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Choose dosage type</mat-label>
            <mat-select required (selectionChange)="getPackageTypes($event.value)" [(ngModel)]="data.dosageTypeId">
                <mat-option *ngFor="let type of dosageTypes" value="{{type.id}}">
                    {{type.additional_information}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </p>
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Add packages</mat-label>
            <mat-chip-list #chipList aria-label="Package type selection">
                <mat-chip *ngFor="let packageType of selectedPackageTypes" (removed)='removePackageType(packageType.id)'>
                    {{packageType.type}}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
                <input required #packageTypeInput [formControl]="packageTypesCtrl" placeholder="Add package type" [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addPackageType($event)">
            </mat-chip-list>
            <mat-autocomplete (optionSelected)="selectPackageType($event)" #auto="matAutocomplete">
                <mat-option *ngFor="let type of filteredPackageTypes | async" [value]="type">
                    {{type.type}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button color='primary' mat-raised-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
</div>